import React, { Suspense, lazy } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import PageLoader from './components/Common/PageLoader';
import Base from './components/Layout/Base';
import BasePage from './components/Layout/BasePage';
import history from './history';
import waitFor from './utils/waitFor';

const CatalogosRouter = lazy(() => import('./components/Catalogos'));
const PrenominaRouter = lazy(() => import('./components/Prenomina'));
const OperacionesRouter = lazy(() => import('./components/Operaciones'));
const PortalClienteRouter = lazy(() => import('./components/PortalCliente'));
const FacturacionesRouter = lazy(() => import('./components/Facturaciones'));
const DispersionesRouter = lazy(() => import('./components/Dispersion'))
const Reportes = lazy(() => import('./components/Reportes'));
const InicioRouter = lazy(() => import('./components/Inicio'));
const Login = lazy(() => import('./components/Account/Login'));
const SolicitarContrasena = lazy(() =>
  import('./components/Account/SolicitarContrasena')
);
const RecuperarContrasena = lazy(() =>
  import('./components/Account/RecuperarContrasena')
);
const VerificarCorreo = lazy(() =>
  import('./components/Account/VerificarCorreo')
);

const listofPages = [
  '/login',
  '/solicitar-contrasena',
  '/recuperar-contrasena',
  '/verificar-correo'
];

const Routes = ({ location }) => {
  const currentKey = location.pathname.split('/')[1] || '/';
  const timeout = { enter: 0, exit: 500 };

  const animationName = 'rag-fadeInLeft';

  if (listofPages.indexOf(location.pathname) > -1) {
    return (
      <BasePage>
        <Suspense fallback={<PageLoader />}>
          <Switch location={location}>
            <Route path='/login' component={waitFor(Login)} />
            <Route
              path='/solicitar-contrasena'
              component={waitFor(SolicitarContrasena)}
            />
            <Route
              path='/recuperar-contrasena'
              component={waitFor(RecuperarContrasena)}
            />
            <Route
              path='/verificar-correo'
              component={waitFor(VerificarCorreo)}
            />
          </Switch>
        </Suspense>
      </BasePage>
    );
  } else {
    return (
      <>
        {localStorage.getItem('SHERPA_AUTH_JWT_ID') ? (
          <Base>
            <TransitionGroup style={{ marginTop: 50 }}>
              <CSSTransition
                key={currentKey}
                timeout={timeout}
                classNames={animationName}
                exit={false}
                in={false}
              >
                <div>
                  <Suspense fallback={<PageLoader />}>
                    <Switch location={location}>
                      <Route exact path='/inicio' component={InicioRouter} />
                      <Route path='/prenomina' component={PrenominaRouter} />
                      <Route path='/catalogos' component={CatalogosRouter} />
                      <Route
                        path='/operaciones'
                        component={OperacionesRouter}
                      />
                      <Route
                        path='/portalCliente'
                        component={PortalClienteRouter}
                      />
                      {/* <Route path='/facturaciones' component={FacturacionesRouter} /> */}
                      <Route path='/dispersiones' component={DispersionesRouter} />
                      <Route path='/reportes' component={waitFor(Reportes)}/>
                      <Redirect from='**' to='/inicio' />
                    </Switch>
                  </Suspense>
                </div>
              </CSSTransition>
            </TransitionGroup>
          </Base>
        ) : (
          history.push('/login')
        )}
      </>
    );
  }
};

export default withRouter(Routes);
